import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'gen-statistics-sections',
  templateUrl: './statistics-sections.component.html',
  styleUrls: ['statistics-sections.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class StatisticsSectionsComponent {
  @Input() statisticsSections: any;

  originalOrder() {
    return 0;
  }

}
